import { combineReducers } from 'redux';

import resequencingReducer from './features/resequencing/resequencingSlice';

const rootReducer = combineReducers({
  resequencing: resequencingReducer,
});

export default rootReducer;
